module.exports = __webpack_public_path__ + "img/check-azul.ad5de74e.png";